import _regeneratorKeys from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js";
import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
import { Message } from 'element-ui';
import MemberEdit from '../member/info3/index';
export default {
  name: 'PlatformResourcesMemberList',
  components: {
    MemberEdit: MemberEdit
  },
  data: function data() {
    return {
      memberStsData: {},
      addAngleDialogVisible: false,
      addAngleDisabled: false,
      editVauDialogVisible: false,
      editVauDisabled: false,
      pushMessageDisable: false,
      pushMessageDialogVisible: false,
      addCurrencyDisable: false,
      addCurrencyDialogVisible: false,
      addMemberDisable: false,
      addMembeDialogVisible: false,
      allHeights: [],
      memberAnnualIncomes: [],
      isSelect: this.checkauthority('member_select'),
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      activeName: 'default',
      selectForm: {
        registerTime: [],
        memberTime: [],
        nickName: '',
        sex: '',
        name: '',
        headUrl: '',
        phone: '',
        userName: '',
        passWord: '',
        wxMiniOpenid: '',
        loginTime: null,
        loginNum: null,
        loginDevice: '',
        province: '',
        city: '',
        area: '',
        longitude: '',
        latitude: '',
        pvAuth: '',
        memberType: '',
        privateLetterNum: null,
        acceptNum: null,
        memberStartTime: null,
        memberEndTime: null,
        warningsNum: null,
        currencyNum: null,
        memberSts: null,
        createTime: null,
        memberNo: '',
        source: '',
        sortType: 1,
        startAge: null,
        endAge: null,
        education: null,
        marriage: null,
        carPurchase: null,
        buyHouse: null,
        noOrPhone: null,
        selectCitys: [],
        authentication: null,
        memberStats: '',
        loginTimes: [],
        matchmakerName: null,
        agencyName: null,
        endHeight: null,
        startHeight: null,
        annualIncomes: null
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      provinces: [],
      citys: [],
      sex: [],
      memberV: [],
      memberTypes: [],
      memberSources: [],
      minAges: [],
      maxAges: [],
      educations: [],
      carPurchases: [],
      buyHouses: [],
      marriages: [],
      memberSumCounts: {}
    };
  },
  methods: {
    updateHomeTopApi: function updateHomeTopApi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = [];
              _this.tableSelects.forEach(function (element) {
                par.push(element.memberId);
              });
              if (par.length === 0) {
                Message.error('请选择会员');
              } else {
                _this.$confirm('确定要取消推荐吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                  var index, id, proItem, _t, _t2;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _t = _regeneratorKeys(par);
                      case 1:
                        if ((_t2 = _t()).done) {
                          _context.n = 3;
                          break;
                        }
                        index = _t2.value;
                        id = par[index];
                        proItem = {
                          memberId: id,
                          homeTop: 0
                        };
                        _context.n = 2;
                        return api.UPDATE_MEMBER(proItem);
                      case 2:
                        _context.n = 1;
                        break;
                      case 3:
                        _this.initTableData();
                        _this.$message.success('操作成功');
                      case 4:
                        return _context.a(2);
                    }
                  }, _callee);
                }))).catch(function () {
                  _this.$message({
                    type: 'info',
                    message: '已取消操作'
                  });
                });
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    exportExcel: function exportExcel() {
      var par = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        nickName: this.selectForm.nickName,
        sex: this.selectForm.sex,
        name: this.selectForm.name,
        headUrl: this.selectForm.headUrl,
        phone: this.selectForm.phone,
        userName: this.selectForm.userName,
        pvAuth: this.selectForm.pvAuth,
        memberType: this.selectForm.memberType,
        privateLetterNum: this.selectForm.privateLetterNum,
        acceptNum: this.selectForm.acceptNum,
        memberStartTime: this.selectForm.memberStartTime,
        memberEndTime: this.selectForm.memberEndTime,
        warningsNum: this.selectForm.warningsNum,
        currencyNum: this.selectForm.currencyNum,
        memberSts: this.selectForm.memberSts,
        memberNo: this.selectForm.memberNo,
        source: this.selectForm.source,
        sortType: this.selectForm.sortType,
        endAge: this.selectForm.endAge,
        startAge: this.selectForm.startAge,
        marriage: this.selectForm.marriage,
        carPurchase: this.selectForm.carPurchase,
        buyHouse: this.selectForm.buyHouse,
        education: this.selectForm.education,
        noOrPhone: this.selectForm.noOrPhone,
        authentication: this.selectForm.authentication,
        memberStats: this.selectForm.memberStats,
        matchmakerName: this.selectForm.matchmakerName,
        agencyName: this.selectForm.agencyName,
        startHeight: this.selectForm.startHeight,
        endHeight: this.selectForm.endHeight
      };
      if (this.selectForm.selectCitys.length > 0) {
        par.province = this.selectForm.selectCitys[0];
        par.city = this.selectForm.selectCitys[1];
        if (this.selectForm.selectCitys.length > 2) {
          par.area = this.selectForm.selectCitys[2];
        }
      }
      if (this.selectForm.registerTime.length >= 2) {
        par.registerStartTime = this.selectForm.registerTime[0];
        par.registerEndTime = this.selectForm.registerTime[1];
      }
      if (this.selectForm.memberTime.length >= 2) {
        par.memberSelStartTime = this.selectForm.memberTime[0];
        par.memberSelEndTime = this.selectForm.memberTime[1];
      }
      if (this.selectForm.loginTimes.length >= 2) {
        par.loginStartTime = this.selectForm.loginTimes[0];
        par.loginEndTime = this.selectForm.loginTimes[1];
      }
      var apiUrl = 'admin/v1/member/exportPageList';
      this.downloadUtil.excelExport(apiUrl, par, '会员统计表.xls');
    },
    addAngleInitData: function addAngleInitData() {
      this.initTableData();
    },
    addAngleShow: function addAngleShow() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.addAngleDialogVisible = true;
      this.$refs.addAngle.setTitle('赠送相亲卡');
      this.$refs.addAngle.initData(par);
    },
    addAngleClose: function addAngleClose() {
      this.addAngleDialogVisible = false;
    },
    editVauOpen: function editVauOpen() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.$refs.editVau.setTitle('加V认证');
      this.$refs.editVau.setData(par);
      this.editVauDialogVisible = true;
    },
    editVauInitData: function editVauInitData() {
      this.initTableData();
    },
    editVauClose: function editVauClose() {
      this.editVauDialogVisible = false;
    },
    exportMember: function exportMember() {
      Message.error('业务完善在做');
    },
    changeVac: function changeVac(type) {
      return this.enums.checkEnumsValue(this.memberV, type, '-');
    },
    changeMemberType: function changeMemberType(type) {
      return this.enums.checkEnumsValue(this.memberTypes, type, '-');
    },
    changeSex: function changeSex(type) {
      return this.enums.checkEnumsValue(this.sex, type, '-');
    },
    addWarning: function addWarning() {
      var _this2 = this;
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
      } else {
        this.$confirm('确定警告该用户？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          var data = {
            memberIds: par,
            warningsNum: 1
          };
          _this2.addWarningApi(data);
        }).catch(function () {
          _this2.$message({
            type: 'info',
            message: '已取消修改'
          });
        });
      }
    },
    openAddMember: function openAddMember() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.addMembeDialogVisible = true;
      this.$refs.addMember.setTitle('开通会员');
      this.$refs.addMember.initData(par);
    },
    addMemberClose: function addMemberClose() {
      this.addMembeDialogVisible = false;
    },
    openPushMessage: function openPushMessage() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.pushMessageDialogVisible = true;
      this.$refs.pushMessage.setTitle('推送消息');
      this.$refs.pushMessage.initMemberData(par);
    },
    pushMessageClose: function pushMessageClose() {
      this.pushMessageDialogVisible = false;
    },
    openAddCurrency: function openAddCurrency() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.addCurrencyDialogVisible = true;
      this.$refs.addCurrency.setTitle('赠币');
      this.$refs.addCurrency.initData(par);
    },
    addCurrencyClose: function addCurrencyClose() {
      this.addCurrencyDialogVisible = false;
    },
    sortChange: function sortChange(op) {
      this.pageNo = 1;
      if (op === 'default') {
        this.selectForm.sortType = 1;
      } else if (op === 'activity') {
        this.selectForm.sortType = 2;
      } else if (op === 'fans') {
        this.selectForm.sortType = 3;
      } else if (op === 'recharge') {
        this.selectForm.sortType = 4;
      } else if (op === 'loginTime') {
        this.selectForm.sortType = 5;
      } else if (op === 'homeTop') {
        this.selectForm.sortType = 6;
      }
      this.initTableData();
    },
    initEunmData: function initEunmData() {
      var thiz = this;
      this.enums.getMemberAllHight(function (arg) {
        thiz.allHeights = arg;
        console.log(thiz.allHeights);
      });
      this.enums.getMemberAnnualIncomes(function (arg) {
        thiz.memberAnnualIncomes = arg.body;
      });
      this.getSexEnumList('member_sex');
      this.getMemberVList('member_v');
      this.getMemberTypeList('member_type');
      this.getMemberSourcesList('member_source');
      this.getMemberAgeEnumList();
      this.getEducationsEnumList();
      this.getBuyHousesEnumList();
      this.getMarriagesEnumList();
      this.getCarPurchasesEnumList();
    },
    getCarPurchasesEnumList: function getCarPurchasesEnumList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: 'member_car_select'
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this3.carPurchases = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getMarriagesEnumList: function getMarriagesEnumList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                name: 'mbmber_marriage_select'
              };
              _context4.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context4.v;
              _this4.marriages = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getBuyHousesEnumList: function getBuyHousesEnumList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                name: 'member_buyHouse_select'
              };
              _context5.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context5.v;
              _this5.buyHouses = res.body;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getEducationsEnumList: function getEducationsEnumList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var par, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              par = {
                name: 'mbmber_education_select'
              };
              _context6.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context6.v;
              _this6.educations = res.body;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getMemberAgeEnumList: function getMemberAgeEnumList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var par, res, data, index, item, values, min, max, datas, i;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              par = {
                name: 'member_age_select'
              };
              _context7.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context7.v;
              data = res.body;
              for (index in data) {
                item = data[index];
                values = item.values.split('-');
                min = values[0];
                max = values[1];
                datas = [];
                for (i = parseInt(min); i <= parseInt(max); i++) {
                  datas.push(i);
                }
                if (item.keys === 'max') {
                  _this7.maxAges = datas;
                } else {
                  _this7.minAges = datas;
                }
              }
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getMemberSourcesList: function getMemberSourcesList(name) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var par, res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              par = {
                name: name
              };
              _context8.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context8.v;
              _this8.memberSources = res.body;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    getMemberTypeList: function getMemberTypeList(name) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var par, res;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              par = {
                name: name
              };
              _context9.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context9.v;
              _this9.memberTypes = res.body;
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    getMemberVList: function getMemberVList(name) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var par, res;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              par = {
                name: name
              };
              _context0.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context0.v;
              _this0.memberV = res.body;
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    getSexEnumList: function getSexEnumList(name) {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var par, res;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              par = {
                name: name
              };
              _context1.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context1.v;
              _this1.sex = res.body;
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this10 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this10.daleteApi(index, data);
      }).catch(function () {
        _this10.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var par;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              par = {
                memberId: data.memberId
              };
              _context10.n = 1;
              return api.DELETE_MEMBER(par);
            case 1:
              _this11.initTableData();
            case 2:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.n = 1;
              return api.DELETE_BATCH_MEMBER(par);
            case 1:
              _this12.$message.success('操作成功');
              _this12.initTableData();
            case 2:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this13 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this13.tableSelects.forEach(function (element) {
          par.push(element.memberId);
        });
        _this13.deleteBatchApi(par);
      }).catch(function () {
        _this13.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('会员详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.endAge = null;
      this.selectForm.startAge = null;
      this.selectForm.registerTime = [];
      this.selectForm.memberTime = [];
      this.selectForm.nickName = '';
      this.selectForm.sex = '';
      this.selectForm.name = '';
      this.selectForm.headUrl = '';
      this.selectForm.phone = '';
      this.selectForm.userName = '';
      this.selectForm.passWord = '';
      this.selectForm.wxMiniOpenid = '';
      this.selectForm.loginTime = null;
      this.selectForm.loginNum = null;
      this.selectForm.loginDevice = '';
      this.selectForm.province = '';
      this.selectForm.city = '';
      this.selectForm.area = '';
      this.selectForm.longitude = '';
      this.selectForm.latitude = '';
      this.selectForm.pvAuth = '';
      this.selectForm.memberType = '';
      this.selectForm.privateLetterNum = null;
      this.selectForm.acceptNum = null;
      this.selectForm.memberStartTime = null;
      this.selectForm.memberEndTime = null;
      this.selectForm.warningsNum = null;
      this.selectForm.currencyNum = null;
      this.selectForm.memberSts = null;
      this.selectForm.createTime = null;
      this.selectForm.memberNo = '';
      this.selectForm.source = '';
      this.selectForm.marriage = '';
      this.selectForm.carPurchase = '';
      this.selectForm.buyHouse = '';
      this.selectForm.education = '';
      this.selectForm.noOrPhone = '';
      this.selectForm.selectCitys = [];
      this.selectForm.authentication = '';
      this.selectForm.memberStats = '';
      this.selectForm.loginTimes = [];
      this.selectForm.matchmakerName = null;
      this.selectForm.agencyName = null;
      this.selectForm.endHeight = null;
      this.selectForm.startHeight = null;
      this.selectForm.annualIncomes = null;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var par, res;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              par = {
                pageNo: _this14.pageNo,
                pageSize: _this14.pageSize,
                nickName: _this14.selectForm.nickName,
                sex: _this14.selectForm.sex,
                name: _this14.selectForm.name,
                headUrl: _this14.selectForm.headUrl,
                phone: _this14.selectForm.phone,
                userName: _this14.selectForm.userName,
                pvAuth: _this14.selectForm.pvAuth,
                memberType: _this14.selectForm.memberType,
                privateLetterNum: _this14.selectForm.privateLetterNum,
                acceptNum: _this14.selectForm.acceptNum,
                memberStartTime: _this14.selectForm.memberStartTime,
                memberEndTime: _this14.selectForm.memberEndTime,
                warningsNum: _this14.selectForm.warningsNum,
                currencyNum: _this14.selectForm.currencyNum,
                memberSts: _this14.selectForm.memberSts,
                memberNo: _this14.selectForm.memberNo,
                source: _this14.selectForm.source,
                sortType: _this14.selectForm.sortType,
                endAge: _this14.selectForm.endAge,
                startAge: _this14.selectForm.startAge,
                marriage: _this14.selectForm.marriage,
                carPurchase: _this14.selectForm.carPurchase,
                buyHouse: _this14.selectForm.buyHouse,
                education: _this14.selectForm.education,
                noOrPhone: _this14.selectForm.noOrPhone,
                authentication: _this14.selectForm.authentication,
                memberStats: _this14.selectForm.memberStats,
                matchmakerName: _this14.selectForm.matchmakerName,
                agencyName: _this14.selectForm.agencyName,
                startHeight: _this14.selectForm.startHeight,
                endHeight: _this14.selectForm.endHeight,
                annualIncomes: _this14.selectForm.annualIncomes
              };
              if (_this14.selectForm.selectCitys.length > 0) {
                par.province = _this14.selectForm.selectCitys[0];
                par.city = _this14.selectForm.selectCitys[1];
                if (_this14.selectForm.selectCitys.length > 2) {
                  par.area = _this14.selectForm.selectCitys[2];
                }
              }
              if (_this14.selectForm.registerTime.length >= 2) {
                par.registerStartTime = _this14.selectForm.registerTime[0];
                par.registerEndTime = _this14.selectForm.registerTime[1];
              }
              if (_this14.selectForm.memberTime.length >= 2) {
                par.memberSelStartTime = _this14.selectForm.memberTime[0];
                par.memberSelEndTime = _this14.selectForm.memberTime[1];
              }
              if (_this14.selectForm.loginTimes.length >= 2) {
                par.loginStartTime = _this14.selectForm.loginTimes[0];
                par.loginEndTime = _this14.selectForm.loginTimes[1];
              }
              _context12.n = 1;
              return api.GET_MEMBER_PAGE_LIST(par);
            case 1:
              res = _context12.v;
              _this14.tableData = res.body.datas;
              _this14.pageTotal = res.body.sumDataCount;
            case 2:
              return _context12.a(2);
          }
        }, _callee12);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    },
    initProvinces: function initProvinces() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var res;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return api.GET_PROVINCE_LIST();
            case 1:
              res = _context13.v;
              _this15.provinces = res.body;
            case 2:
              return _context13.a(2);
          }
        }, _callee13);
      }))();
    },
    initCitys: function initCitys() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var res;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              _context14.n = 1;
              return api.GET_BYCITYOPENING_SELECT_TREE_LIST({});
            case 1:
              res = _context14.v;
              _this16.citys = res.body;
            case 2:
              return _context14.a(2);
          }
        }, _callee14);
      }))();
    },
    initStsMemberNum: function initStsMemberNum() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var res;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              _context15.n = 1;
              return api.GET_INDEX_TOTAL_STATISTICS();
            case 1:
              res = _context15.v;
              _this17.memberStsData = res.body;
            case 2:
              return _context15.a(2);
          }
        }, _callee15);
      }))();
    },
    addWarningApi: function addWarningApi(data) {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              _context16.n = 1;
              return api.ADD_MEMBER_WARNING(data);
            case 1:
              Message.success('操作成功');
              _this18.initTableData();
            case 2:
              return _context16.a(2);
          }
        }, _callee16);
      }))();
    },
    getMemberSumCounts: function getMemberSumCounts() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        var res;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              _context17.n = 1;
              return api.GET_MEMBER_SUM_COUNT();
            case 1:
              res = _context17.v;
              _this19.memberSumCounts = res.body;
            case 2:
              return _context17.a(2);
          }
        }, _callee17);
      }))();
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    // this.getMemberSumCounts()
    this.initCitys();
    this.initEunmData();
    this.initTableData();
    this.initStsMemberNum();
  }
};